<template>
  <transition-fade>
    <h4 v-if='!loading && from && from.params.primi'>
      <router-link v-if='!clicked && pageToGoBackTo == from.params.primi' :to='from.path' @click='click(1)'>
        <svg class='btn-icon' viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 13L1 7L7 1M1 7H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Back
      </router-link>
      <!--<router-link v-if='clicked' :to='from.path' @click='click(0)'>
        Back →
      </router-link>-->
    </h4>
  </transition-fade>
</template>

<script setup>
import { TransitionFade } from '@morev/vue-transitions';
import { useStore } from '../KQL.js'
import { watch, ref, onUnmounted } from 'vue'
const props = defineProps(['from', 'pageToGoBackTo']);
const kql = useStore();
const loading = ref(1);
const clicked = ref(0);
var clickedTimeOut, loadingTimeOut
const click = (value) => {clickedTimeOut = setTimeout(() => { clicked.value=value }, 750)};
watch(kql, (kql) => {
  if(!kql.loading) {loadingTimeOut = setTimeout(() => { loading.value=0; }, 1000)};
  if(kql.loading) loading.value=1;  clicked.value=0;
})
onUnmounted(()=> {clearTimeout(clickedTimeOut); clearTimeout(loadingTimeOut);});
</script>

<style scoped>
.btn-icon {
  height: 0.75em;
  width: auto;
  transform: translateY(-0.05em);
}
</style>
